/**
 * Wishlist icon component
 * 
 * @module wishlist-icon
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'wishlist-icon';

if(!customElements.get(customElements.component)) {

    class wishlistIcon extends HTMLElement {

        /**
         * Web component constructor
         * 
         * @constructor
         */
        constructor() {

            super();

            this.initEvents();
        }
        
        /**
         * Init component events
         * 
         * @returns {undefined}
         */
        initEvents() {

            let isWishlistApp = (typeof this.dataset.wishlistPlus != 'undefined') ? true : false;
            if(!isWishlistApp){
                this.addEventListener('click', () => {
                    this.classList.toggle('active');
                });
            }

            let initWishlist = (typeof this.dataset.wishlistPlusInitParentSelector != 'undefined') ? true : false;
            if(initWishlist){
                this.initWishlistPlusButtons()
            }

        }

        /**
         * Init Wishlist Plus buttons
         * 
         * @returns {undefined}
         */
        initWishlistPlusButtons() {

            if(this.classList.contains("swym-loaded")){
                return;
            }

            let selector = this.dataset.wishlistPlusInitParentSelector;
            if(window._swat){
                window._swat.initializeActionButtons(selector);
            }else{
                window.SwymCallbacks = window.SwymCallbacks || [];
                window.SwymCallbacks.push(function(){
                    window._swat.initializeActionButtons(selector);
                });
            }
        }
    }

    customElements.define(customElements.component, wishlistIcon);
}
